/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
import Loginb2cFooter from './loginb2cFooter';
import { DMNNM } from '../configs/ops';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class ExchangeSoccerSEO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection: "",
            clientWidth: document.documentElement.clientWidth,
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }



    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]: false })

    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = "") {
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name) {
        this.setState({ selectedSection: this.state.selectedSection === name ? "" : name });
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
            <div className="radheexch radheexchlogin bg-white-login ">


                <Loginb2cHeader history={this.props.history}></Loginb2cHeader>
                {/* <div className='login-mar-top100'>
            <section className='sportbook-screen'>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen.jpg"} className="sp-desktop-show" /></a>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen-mobile.jpg"} className="sp-mobile-show" /></a>
            </section>
        </div> */}
                <div className='login-mar-top100 '>
                    <section className='sportbook-livecasino'>
                        <div>
                            <img alt="Exchange Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchanges-banner.jpg"} />

                        </div>
                        <div>
                            <div className="">
                                <div className='seo-content-page'>
                                    <h2 align="center">Are You Soccer Smart? Play and Win at {DMNNM}</h2>
                                    <p>
                                        The heroics of Ronaldo and Messi have created a generation of Soccer lovers
                                        in India, even as the Soccer team of our country still struggles to find a
                                        place on the world stage. The Soccer fans are definitely way ahead in their
                                        maturity than the national teams as they are often able to guess who will
                                        make the next goal. How many times has something similar happened to you?
                                        If the answer is quite a few times, then you can use that intuition of
                                        yours to make money through <strong>Soccer gambling</strong>. While many
                                        conservative minds tend to see all forms of gambling, including Soccer
                                        gambling, as some sort of vice, there is no sufficient reason to exercise
                                        such censor on it as betting or gambling is only bad if it becomes
                                        addictive. And for most fans, it is not a problem. Anyway, as long as
                                        people are well aware of the risks of the game and can exercise
                                        self-discipline, there need be no moral qualms about the game.
                                    </p>
                                    <p>
                                        As for sports-based gambling, like Soccer gambling, it is not much
                                        different from many high-risk investments where one only invests with the
                                        expectation of high returns. That might explain why    <strong> Soccer online betting </strong>is growing so popular these days.
                                        And it is easy too. All you need for    <strong>Soccer online betting </strong>is some sparable money; then, you
                                        can easily create an <strong>online Soccer id, </strong>and you are good to
                                        place your bets.
                                    </p>
                                    <p>
                                        Before you raise any such questions, we must clarify that    <strong>Soccer gambling </strong>is completely legal for all adults. So,
                                        you don't have to worry about doing anything illegal, and as you are not
                                        addicted or encouraging underage people to gamble, you aren't doing
                                        anything unethical either. It is true that gambling can be addictive, but
                                        most mature minds are capable of stopping long before it matures into a
                                        problem. And legal framework provides protection to those who may not be
                                        able to do so - that is, young people or those who are not of sound mind.
                                    </p>
                                    <p>
                                        Does that interest you? Let us explore the various aspects of    <strong>online Soccer betting games </strong>in detail.
                                    </p>
                                    <p>
                                        <strong>
                                            Soccer Betting - The Best Way To Show Your Love For The Sport
                                        </strong>
                                    </p>
                                    <p>
                                        Soccer is the most popular sport in the world - played in almost every
                                        single country in the world; it has found enthusiasts even in a country
                                        like India, which has never been a strong Soccer nation. Soccer fever can,
                                        at times, gets to so much excess that some people are seen playing Soccer
                                        even when they are not wearing the right shoes for the same. That's just
                                        what Soccer means to its lovers. If you are such a Soccer fan, then with so
                                        much of your mental space being occupied by the game, you are likely to
                                        develop a sort of intuition for its various and can 'see' things coming. In
                                        such a case, <strong>online Soccer betting </strong>is just the next
                                        natural step for you.
                                    </p>
                                    <p>
                                        While there are several perks of <strong>Soccer gambling</strong> - the
                                        most important of those include the following:
                                    </p>
                                    <p>
                                        ● Watching Soccer is far more thrilling when you have your bets on.
                                    </p>
                                    <p>
                                        ● A perfect way of putting one's understanding of Soccer into the
                                        application.
                                    </p>
                                    <p>
                                        ● One of the easiest and smartest ways of making some money.
                                    </p>
                                    <p>
                                        ● It fills one with a sense of adventure.
                                    </p>
                                    <p>
                                        ● It is a good way of getting more investment into the game by giving a
                                        financial expression to your emotional investment and your confidence in
                                        your favorite Soccer.
                                    </p>
                                    <p>
                                        ● It is far more information and analysis based than other forms of
                                        gambling that are completely luck-based.
                                    </p>
                                    <p>
                                        ● You are no longer just wasting your time while watching Soccer and
                                        actually stand a chance to earn something out of it.
                                    </p>
                                    <p>
                                        These benefits will convince most Soccer lovers to give Soccer bets a try.
                                    </p>
                                    <p>
                                        <strong>Online Platforms Make Betting Smooth</strong>
                                    </p>
                                    <p>
                                        The recent popularity of <strong>Soccer gambling </strong>is mostly owed to
                                        the increased internet penetration in the country. As a result, there has
                                        been an emergence of <strong>online Soccer betting games </strong>in India.
                                        While online betting has been around for a while, the ease of internet
                                        access through mobile apps and the increased availability of smartphones
                                        have acted as a catalyst for the popular    <strong>online Soccer betting games</strong>.
                                    </p>
                                    <p>
                                        These online games are fairly easy to play and participate in. If you want
                                        to <strong>bet fair Soccer</strong>, all you need is a stable internet
                                        connection, a phone or computer to access it, and an    <strong>online Soccer id</strong>. There are several additional advantages
                                        of going <strong>Soccer online betting</strong> apart from those mentioned
                                        above:
                                    </p>
                                    <p>
                                        ● You can readily cash in your winnings. As you win your bets, it is easy
                                        to collect your bets, and you can do it through many options. However, you
                                        should make a point of checking whether the payment option is safe.
                                    </p>
                                    <p>
                                        ● Far more convenient and comfortable than traditional Soccer bettering as
                                        you don't have to stand in queues, meet or call anyone; you can just do it
                                        through a few simple clicks on your screen at any place.
                                    </p>
                                    <p>
                                        ● Soccer data can be far more readily available online.
                                    </p>
                                    <p>
                                        ● The gaming platforms for <strong>online Soccer betting games </strong>are
                                        far better regulated.
                                    </p>
                                    <p>
                                        ● <strong>Soccer online betting</strong> offers far better rewards for bets
                                        in general.
                                    </p>
                                    <p>
                                        ● As mentioned above, it is even more fun than traditional betting.
                                    </p>
                                    <p>
                                        ● It is simply too irresistible for true Soccer lovers.
                                    </p>
                                    <p>
                                        From the above discussion, we can easily conclude that online Soccer
                                        betting games are the perfect way to <strong>bet fair Soccer</strong>.
                                    </p>
                                    <p>
                                        <strong>
                                            Importance Of Choosing The Right Platform For Soccer Gambling
                                        </strong>
                                    </p>
                                    <p>
                                        One of the most valuable considerations with regard to    <strong>Soccer gambling</strong> is that one should choose one's platform
                                        carefully. Several valuable factors should be considered before selecting
                                        the platform. One should only get <strong>an online Soccer id</strong> only
                                        after careful scrutiny of the vendor.
                                    </p>
                                    <p>
                                        Some of the most important things to consider while choosing the Soccer
                                        betting vendor include the privacy policy, clauses regarding the safety of
                                        the information you and your money, the kinds of bets offered, and the
                                        average reward payback time period, which the vendor typically requires to
                                        pay the winnings. One should make a list of different vendors to begin
                                        with, and only after a careful analysis of various vendors based on these
                                        considerations can one make the best-informed decision. Your other safe bet
                                        is to go {DMNNM}.
                                    </p>
                                    <p>
                                        <strong>Your One And Perfect Place For Soccer Betting</strong>
                                    </p>
                                    <p>
                                        {DMNNM} is like Aladdin's lamp when it comes to online sports betting - you
                                        can place bets on various kinds of games with us. Most people will find
                                        that {DMNNM} will come out on top with all the criteria mentioned here in
                                        the previous section. What makes us a favorite among those thousands
                                        looking to <strong>bet fair Soccer </strong>is our highly innovative and
                                        convenient options for placing the bets.
                                    </p>
                                    <p>
                                        With {DMNNM}, you can easily bet on all kinds of international Soccer
                                        matches as well as other matches, including the popular FIFA Soccer world
                                        cup matches - one of the biggest sporting and sports betting events in the
                                        world. Our service is not limited to    <strong>online Soccer betting games </strong>either but also extends to
                                        several other online games. And the cherry on the cake is that you can play
                                        all these games using Indian currency only - thus providing an easy
                                        platform to millions of Soccer lovers.
                                    </p>
                                    <p>
                                        It is just easy to <strong>bet fair Soccer </strong>with us, and you won't
                                        require any kind of technical expertise or knowledge of the game for it
                                        (though the latter helps a lot). It just takes a few minutes to create your    <strong>online Soccer id. </strong>It is vital to play it smart when you
                                        are playing <strong>online Soccer betting games</strong>. With {DMNNM}, you
                                        can easily monitor your bets with the bet slip we provide on our website.
                                        Thus, one should carefully keep sight of scores when betting.
                                    </p>
                                    <p>
                                        In case you have any doubts or queries, you can chat with us through a
                                        website online or contact us through one of several social media links
                                        provided on the website.
                                    </p>
                                    <p>
                                        Of course, these are only some of the various games to bet on. There are,
                                        of course, many other subsets of Soccer, such as the FIFA World Cup, UEFA
                                        Champions League, Confederations Cup, UEFA Europa League, etc., on which
                                        one can bet.
                                    </p>
                                    <p>
                                        <strong>Smart Tips For Getting Started With Soccer Betting</strong>
                                    </p>
                                    <p>
                                        Are you a beginner in <strong>Soccer online betting</strong>? Well, in that
                                        case, let us start by wishing you the best of luck on your maiden bet.
                                        However, we have more than just wishes to offer you. Here are some of the
                                        tips that come in handy when playing <strong>online betting games</strong>:
                                    </p>
                                    <p>
                                        ● <strong>Do your homework first -</strong> While you may occasionally have
                                        luck while betting blindly, it will be a rare enough event as you will be
                                        like a blind person competing against those with perfect vision. It is thus
                                        better to make a proper study of the Soccer conditions, statics, players'
                                        forms, etc., if you wish to have lasting luck of any kind - that way, you
                                        can make smart forecasts and bet accordingly.
                                    </p>
                                    <p>
                                        ● <strong>First, learn with baby steps</strong> - Don't go all out betting
                                        big from the beginning - that's a silly and expensive rookie mistake. It is
                                        important that one should first learn the various intricacies of online
                                        gambling by making only small bets in the beginning. Only once one has the
                                        taste of what various odds feel like, how it might hurt to lose, should one
                                        go for bigger, more adventurous bets.
                                    </p>
                                    <p>
                                        ● <strong>Show fiscal responsibility</strong> - If you want to    <strong>bet fair Soccer </strong>repeatedly, then know that it is not all
                                        fun and no responsibility. Like all kinds of financial decisions, it will
                                        involve its own financial risks, and you do stand a chance of losing money.
                                        One should thus act on financial prudence and responsibility. Thus, you
                                        should not even think of betting till all your expenses for yourself and
                                        your dependents, rents, etc., are already paid. Only after you have paid
                                        them and have something set aside for rainy days can you consider your free
                                        to bet.
                                    </p>
                                    <p>
                                        ● <strong>Know and respect your financial limits</strong> - No matter how
                                        good you are, it is critical to bet no more than you can afford to lose. It
                                        is also always a smart strategy to fix a limit for yourself as to how much
                                        you are willing to bet in a given period (match, week, month, tournament,
                                        or season) and to respect that limit.
                                    </p>
                                    <p>
                                        ● <strong>When on a losing streak, bet smaller</strong> - Like we just
                                        mentioned, respecting one's financial limits is critical to responsible
                                        gambling. One of the rookie mistakes many gamblers make is of increasing
                                        their bets when they are on a losing streak hoping to make it big by
                                        winning the next one. It is a gambler's fallacy that the law of averages
                                        will apply quickly enough. If the luck is not on your side, it is hardly
                                        wise to give it more ammo to hurt you. It is better to reduce your streaks
                                        on the next games as that shall let you stay in the betting game much
                                        longer.
                                    </p>
                                    <p>
                                        ● <strong>Don't react to winning streaks by betting bigger -</strong>
                                        Similarly, it is stupid to increase your bets just because luck has been on
                                        your side. Your winnings should go to balance out your past and future
                                        losses, and if you still have some surplus left, then use it to reward
                                        yourself with some treat.
                                    </p>
                                    <p>
                                        ● If you are facing trouble in disciplining yourself fiscally, if you    <strong>bet fair Soccer</strong>, then you must take corrective toward it.
                                        If it is still not helping, then you may want to stop it altogether, as the
                                        hard fact is that, in that case, gambling is not for you.
                                    </p>
                                    <p>
                                        As you start your Soccer gambling journey, we hope that these tips and
                                        notes of caution will come in handy for you.
                                    </p>
                                    <p>
                                        <strong>The Smartest Way Of Soccer Gambling For Everyone.</strong>
                                    </p>
                                    <p>
                                        {DMNNM} <strong>online Soccer id </strong>offers the best Soccer gambling
                                        solutions for everyone. With our <strong>online Soccer id</strong>, you
                                        will always find yourself at the top of things, and all the betting options
                                        will be at your fingertips. Being a secure and powerful platform that
                                        avails <strong>online Soccer id </strong>in India, we are trusted by
                                        several customers already and can be a relief for availing the information
                                        about your bet readily available to you.
                                    </p>


                                </div>
                            </div>

                        </div>
                    </section>
                </div>


                <Loginb2cFooter history={this.props.history}></Loginb2cFooter>


            </div>)

    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ExchangeSoccerSEO);